import {useUser} from "./hooks";
import {FREE_TRIAL_DURATION} from "../../constants/membership";

const useFreeTrialDuration = () => {
  const user = useUser();

  if (!user) return FREE_TRIAL_DURATION;

  return user.freeTrialDuration;
};

export {useFreeTrialDuration};
